import React, { useState, useRef, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { LocalizationContext } from '../App';

import { useMediaQuery } from 'react-responsive';
import uuid from 'react-uuid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { ReactSession } from 'react-client-session';
import { MapContainer, TileLayer, Marker, Popup, Circle, Polygon } from 'react-leaflet';
import { ThemeProvider, useTheme, createTheme } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import LoupeActivitySecondaryDetails from './LoupeActivitySecondaryDetails';

const LoupeActivityDetails = props => { 

    

    
    const theme = useTheme();
    const { language, activityCode } = useParams();
    
    const isMobileView = useMediaQuery({
        query: '(max-width: 900px)'
    });
    
    const navigate = useNavigate();    
    const location = useLocation();
    
    const currentActivity = location.state?.activity;
    
    const [ isApproved, setIsApproved ] = useState(false);
    const handleApproval = (event) => {
        setIsApproved(event.target.checked);
    };


    const NavigateToActivity = () => {
        navigate('/activity-content/' + language + "/" + activityCode, { replace : true, state : { activity : currentActivity } } ); 
    }
    
    const NavigateToMap = () => {
        navigate('/activities-here', {replace : true});
    }


    return(

        <LocalizationContext.Consumer>

            { ({strings}) =>             
            
                
                <div className="padding">      


                    <Grid container>

                        <Grid item xs={12} md={12}>
                            <Typography variant="h2" className="activity-title padbottom text-start">{currentActivity.Title}</Typography>                            
                        </Grid>


                        <Grid item xs={12} md={7}>   
                            <Card raised={false} elevation={0}>
                                <CardContent>                     
                                    <Typography color="text.secondary" variant="subtitle1" className="fw-lighter text-start">{strings.getString("texts.details.abstract")}</Typography>                              
                                    <Typography variant="body1" className="mb-5 text-start">{currentActivity.Abstract}</Typography> 

                                     <div className="mb-5">
                                        <FormGroup>
                                            <FormControlLabel 
                                                className="text-start"
                                                control={<Switch checked={isApproved} onChange={handleApproval} />} 
                                                label={
                                                <>
                                                    <Typography variant="body2" className="text-start" gutterBottom component="span">{strings.getString("texts.activity.consent")}</Typography>
                                                </>} />
                                        </FormGroup>
                                    </div> 
                                    
                                    <Stack direction={ isMobileView == true ? 'column' : 'row' }>
                                        <Button
                                            {...(isApproved == true ? {} : {disabled : true})} 
                                            onClick={() => NavigateToActivity()}>{strings.getString("controls.buttons.activity.start")}
                                        </Button>
                                        <Button onClick={() => NavigateToMap()}>{strings.getString("controls.buttons.back")}</Button>
                                    </Stack>

                                </CardContent>
                            </Card>
                        </Grid>

                        <Grid item xs={12} md={5}>
                            { isMobileView == true ? 
                            (
                                <Accordion className="mb-5" elevation={0}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                                        <Typography>{strings.getString("controls.accordeons.details")}</Typography>
                                    </AccordionSummary>                                
                                    <AccordionDetails>
                                        <LoupeActivitySecondaryDetails currentActivity={currentActivity} language={language} activityCode={activityCode}/>
                                    </AccordionDetails>
                                </Accordion>
                            ) : ( 
                                <LoupeActivitySecondaryDetails currentActivity={currentActivity} language={language} activityCode={activityCode}/>
                            )}
                        </Grid>


                    </Grid>


                </div>
                
                
        
            }

        </LocalizationContext.Consumer>

    );

}
export default LoupeActivityDetails;